import React from 'react';

import {
  CapaQuotationChatMessageRfq,
  CapaQuotationChatMessageType
} from '@generated/graphql';

import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';

import { Grid, Divider } from '@material-ui/core';
import { ErrorOutlined } from '@material-ui/icons';

interface Props {
  data?: CapaQuotationChatMessageRfq;
}

const TerminationBubble: React.FC<Props> = ({ data }) => {
  const messageType = data?.messageType ?? undefined;
  const rfqData = data?.rfq ?? undefined;
  const organizationName =
    messageType === CapaQuotationChatMessageType.QuitChatroomPartner
      ? rfqData?.partnerOrganizationName ?? ''
      : rfqData?.userOrganizationName ?? '';
  const managerName =
    messageType === CapaQuotationChatMessageType.QuitChatroomPartner
      ? rfqData?.partnerManagerName ?? ''
      : rfqData?.userManagerName ?? '';

  return (
    <div className="message-container">
      <Divider className="message-divider" />
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <ErrorOutlined
          fontSize="small"
          style={{ fill: colorSet.errorBase, marginBottom: 8 }}
        />
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          align="center"
        >
          <span className="primary-text">
            {organizationName}&nbsp;{managerName}
          </span>
          &nbsp;님이 상담을 종료하셨습니다.
        </CustomizedTypography>
      </Grid>
      <Divider className="message-divider" />
    </div>
  );
};

export default TerminationBubble;
